import { default as DialogButton } from "./DialogButton.vue";
import { default as IconButton } from "./IconButton.vue";
import { default as LinkButton } from "./LinkButton.vue";
import { default as MainContent } from "./MainContent.vue";
import { default as MainStandalone } from "./MainStandalone.vue";
import { default as PlusButton } from "./PlusButton.vue";
import { default as TabButtons } from "./TabButtons.vue";
import { default as TextButton } from "./TextButton.vue";

export const Main = {
    Content: MainContent,
    DialogButton: DialogButton,
    IconButton: IconButton,
    LinkButton: LinkButton,
    PlusButton: PlusButton,
    Standalone: MainStandalone,
    TabButtons: TabButtons,
    TextButton: TextButton,
};
